import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { updateNewsletterChunkAsync } from "editor/actions/newsletter";
import ImageEditor from "components/library/ImageEditor";

class ChunkImageEditor extends React.Component {
  constructor(props) {
    super(props);
    this.onSuccess = this._onSuccess.bind(this);
  }

  _onSuccess(image) {
    return this.props.updateNewsletterChunkAsync(
      this.props.match.params.id,
      this.props.match.params.chunkId,
      {
        primary_image: image.id,
        head_rev: this.props.head_rev,
      }
    );
  }

  render() {
    return (
      <ImageEditor
        {...this.props}
        redirectTo={`/editor/${this.props.match.params.type}/${this.props.match.params.id}/`}
        onSuccess={this.onSuccess}
        imageRequirements={{
          minWidth: 1280,
          minHeight: 720,
        }}
        cropRequirements={{
          "16x9": {
            minWidth: 1280,
            minHeight: 720,
          },
          "4x3": {
            minWidth: 960,
            minHeight: 720,
          },
          "1x1": {
            minWidth: 720,
            minHeight: 720,
          },
        }}
      />
    );
  }
}

ChunkImageEditor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      chunkId: PropTypes.string.isRequired,
    }),
  }),
  updateNewsletterChunkAsync: PropTypes.func.isRequired,
  head_rev: PropTypes.string,
};

const mapStateToProps = state => ({
  head_rev: state.editor.form.head_rev,
});

const mapDispatchToProps = {
  updateNewsletterChunkAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChunkImageEditor);
